import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CameraIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8 11.8653C9.38071 11.8653 10.5 10.746 10.5 9.36526C10.5 7.98455 9.38071 6.86526 8 6.86526C6.61929 6.86526 5.5 7.98455 5.5 9.36526C5.5 10.746 6.61929 11.8653 8 11.8653Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.8 2.36526C9.16931 2.36526 9.50856 2.56881 9.68235 2.89467L10.1843 3.83586C10.3581 4.16172 10.6974 4.36526 11.0667 4.36526H13.5C14.3284 4.36526 15 5.03683 15 5.86526V12.8653C15 13.6937 14.3284 14.3653 13.5 14.3653H2.5C1.67157 14.3653 1 13.6937 1 12.8653V5.86526C1 5.03683 1.67157 4.36526 2.5 4.36526H4.93333C5.30264 4.36526 5.64189 4.16172 5.81569 3.83586L6.31765 2.89467C6.49144 2.56881 6.83069 2.36526 7.2 2.36526H8.8ZM8 13.3653C10.2091 13.3653 12 11.5744 12 9.36526C12 7.15612 10.2091 5.36526 8 5.36526C5.79086 5.36526 4 7.15612 4 9.36526C4 11.5744 5.79086 13.3653 8 13.3653ZM12.5 5.86526C12.5 5.58912 12.7239 5.36526 13 5.36526H13.5C13.7761 5.36526 14 5.58912 14 5.86526V6.36526C14 6.6414 13.7761 6.86526 13.5 6.86526H13C12.7239 6.86526 12.5 6.6414 12.5 6.36526V5.86526Z"
		/>
	</svg>
))
